/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ used: NonNullable<unknown>, max: NonNullable<unknown> }} License_SlotsInputs */



/**
* | output |
* | --- |
* | "{used} of {max} computers" |
*
* @param {License_SlotsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const license_slots = /** @type {((inputs: License_SlotsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<License_SlotsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.used} ordinateur(s) sur ${i?.max}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.used} von ${i?.max} Computern`)
	if (locale === "it") return /** @type {LocalizedString} */ (`${i?.used} di ${i?.max} computer`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`${i?.used} из ${i?.max} компьютеров`)
	if (locale === "es") return /** @type {LocalizedString} */ (`${i?.used} de ${i?.max} equipos`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`${i?.max} 台中的 ${i?.used} 台`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`${i?.max} 台中 ${i?.used} 台`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`${i?.max} में से ${i?.used} कंप्यूटर`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`${i?.used} de ${i?.max} computadores`)
	return /** @type {LocalizedString} */ (`${i?.used} of ${i?.max} computers`)
});